import * as THREE from 'three'
import React, { Suspense, useState, useEffect } from 'react'
import { Canvas, useLoader, useFrame } from 'react-three-fiber'
import { useTransition, a } from 'react-spring'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { OrbitControls, draco, Stars } from 'drei'
import Dialog from "@material-ui/core/Dialog";
import {firestore} from "./firebase";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import DialogContent from "@material-ui/core/DialogContent";
import {MP3Player} from "./Mp3Player";



function BasicModel({ url, ...props }) {
    const ref = React.useRef();
    const { scene } = useLoader(GLTFLoader, url, draco());

    return (
        <primitive ref={ref} object={scene} dispose={null} {...props}/>
    )
}


function Loading() {
  const [finished, set] = useState(false)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    THREE.DefaultLoadingManager.onLoad = () => set(true)
    THREE.DefaultLoadingManager.onProgress = (url, itemsLoaded, itemsTotal) =>
      setWidth((itemsLoaded / itemsTotal) * 200)
  }, [])

  const props = useTransition(finished, null, {
    from: { opacity: 1, width: 0 },
    leave: { opacity: 0 },
    update: { width },
  })

  return props.map(
    ({ item: finished, key, props: { opacity, width } }) =>
      !finished && (
        <a.div className="loading" key={key} style={{ opacity }}>
          <div className="loading-bar-container">
            <a.div className="loading-bar" style={{ width }} />
          </div>
        </a.div>
      ),
  )
}


const Plane = ({speed, factor, url, ...props}) => {
    const { animations } = useLoader(GLTFLoader, url)
    const group = React.useRef()
    const [mixer] = useState(() => new THREE.AnimationMixer())
    useEffect(() => void mixer.clipAction(animations[0], group.current).play(), [])
    useFrame((state, delta) => {
        group.current.rotation.y  -= Math.sin((delta * factor) / 2) * Math.cos((delta * factor) / 2) * 1.5
        mixer.update(delta * speed)
    })


    return (
        <group ref={group} dispose={null}>
            <BasicModel url={url} {...props}/>
        </group>)
}

export default function App() {
    const [showCard, setShowCard] = React.useState(false)
    const [showMessage, setShowMessage] = React.useState(false)
  return (
    <>
      <div className="bg" />
      <h1>
        HAPPY BIRTHDAY
        <br />
        <span>CALLIE !</span>
      </h1>
      <Canvas shadowMap camera={{ position: [0, 0, 13] }}>
        <ambientLight intensity={0.75} />
        <pointLight intensity={1} position={[-10, -25, -10]} />
        <spotLight
          castShadow
          intensity={2.25}
          angle={0.2}
          penumbra={1}
          position={[25, 25, 25]}
          shadow-mapSize-width={1024}
          shadow-mapSize-height={1024}
          shadow-bias={-0.0001}
        />
        <Suspense fallback={null}>
          <BasicModel url="/planet_earth/scene.gltf" scale={[0.15,0.15,0.15]} position={[0,0,0]}/>
          <Plane url={'/cartoon_plane/scene.gltf'} scale={[0.0017,0.0017,0.0017]} speed={1} factor={0.6} position={[6.2,1.5,0]}/>
        </Suspense>
        <OrbitControls
          autoRotate
          enablePan={false}
          enableDamping
          dampingFactor={0.5}
          autoRotateSpeed={1}
          maxPolarAngle={Math.PI / 3}
          minPolarAngle={Math.PI / 3}
        />
        <Stars/>
      </Canvas>
      <div className="layer" />
      <Loading />
       <a href='#' onClick={() => setShowCard(true)} className="bottom-left" children="Birthday Card 🎂" />
      <a href='#' onClick={() => setShowMessage(true)} className="bottom-right" children="📧 Message" />
      <Modal open={showMessage} close={() => setShowMessage(false)} component={<MessageMarcus close={() => setShowMessage(false)}/>}/>
      <Modal open={showCard} close={() => setShowCard(false)} component={<BirthdayCard/>}/>
      <MP3Player showCard={showCard}/>
    </>
  )
}


const MessageMarcus = (props) => {
    const [message, setMessage] = React.useState('')
    const [success, setSuccess] = React.useState('')
    const [error, setError] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    const sendMessage = e => {
        e.preventDefault()
        setLoading(true)
        firestore.collection('messages').add({
            message,
        })
            .then(() => {
                props.close()
            })
            .catch(err => {
                setLoading(false)
                setError('Uh oh. For some reason the message did not go through. You could just text Marcus really')
            })
    }

    return(
        <Grid container item xs={12} spacing={1} justify={'center'}>
            {loading && <h3>LOADING...</h3>}
            <Typography style={{fontFamily: "'Josefin Sans', sans-serif"}} align={'center'}>
                You can message me anything! Write a message, review a song, tell a story or even let out a rant. Let me know what you think about music, politics, sports, love, war or anything
                at all. &#128519;
            </Typography>
            <Grid item xs={12}>
                <Typography>{success}</Typography>
                <Typography color={'error'}>{error}</Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField label={"Message Marcus"} variant={'outlined'} fullWidth multiline rows={5} onChange={e => setMessage(e.target.value)} value={message}/>
            </Grid>
            <Grid item xs={12}>
                <Button fullWidth variant={'outlined'} disabled={message === ''} onClick={sendMessage}>
                    Send
                </Button>
            </Grid>
        </Grid>
    )
}

const BirthdayCard = () => {
    return (
        <>
            <Typography variant={'h4'} align={'center'} style={{fontFamily: "'Josefin Sans', sans-serif"}}>
                It's your birthday! &#127873;&#x1F382;&#x1F604;
            </Typography>
            <Typography variant={'h6'}  style={{fontFamily: "'Josefin Sans', sans-serif"}}>
                Callie! It's your 23rd Birthday!
                I've been thinking about it and I decided the number 23 is actually way cooler than the number 21. Michael Jordan, Lebron James and David Beckham all wore the number 23.
                There's a group of people called "23rdian's"
                who practically worship the number 23 and believe it has a mystical power.
                Psalm 23: "The lord is my shepherd..." one of the most beautiful and highly quoted Psalms in the Bible.
                There have been 2 hit movies and 2 hit songs that have all simply been titled "23".
                The first ever morse code transmission was the Bible passage Numbers 23:23 "What hath God wrought?".
                If that's not enough proof then as a fellow 23 year old, I can promise you that being 23 is really amazing.
                It's obvious that your 23rd birthday is supposed to be one of the most special birthdays in your life.
                Since it's so important, I put together a little playlist hoping that it would be one of the many things to make today special.
                If you like, love or hate any of the songs you can let me know by sending me a message!
                I hope you enjoy this as much as I enjoyed making it.
                Have an awesome day Callie! Happy Birthday!

            </Typography>
            <Typography variant={'caption'} style={{fontFamily: "'Josefin Sans', sans-serif"}}>
                P.S. You're cute
            </Typography>
        </>
    )
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction={'left'} ref={ref} {...props} timeout={800}/>;
});

const Modal = props => {
    return(
        <Dialog
        open={props.open}
        onClose={props.close}
        keepMounted={false}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={'sm'}
        scroll={'body'}
    >
        <DialogContent>
            {props.component}
        </DialogContent>
        </Dialog>
    )
}
